import { render, staticRenderFns } from "./trainingEvaluation.vue?vue&type=template&id=0aa41e35"
import script from "./trainingEvaluation.vue?vue&type=script&lang=js"
export * from "./trainingEvaluation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports